import React from 'react'
import { createRoot } from 'react-dom/client'
import QuoteForm from '../components/QuoteForm'

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-react-quote-form]').forEach(container => {
    const props = JSON.parse(container.dataset.reactQuoteForm || '{}')
    const root = createRoot(container)
    root.render(<QuoteForm {...props} />)
  })

  // Quote CTAs point to /offerte-aanvragen; when this page has its own form, scroll to it instead
  const form = document.getElementById('offerte')
  if (form) {
    document.querySelectorAll('a[href="/offerte-aanvragen"], a[href="/offerte"]').forEach(link => {
      link.addEventListener('click', event => {
        event.preventDefault()
        form.scrollIntoView({ behavior: 'smooth', block: 'start' })
      })
    })
  }
})
